module.exports = __webpack_public_path__ + "resources/icon-sticky.cc2fae65586d02e3.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-title/images/icon-sticky.png
// module id = 532
// module chunks = 0 1 2 3